import { CREATE_ONE_ANNOUNCE, GET_ANNOUNCES } from '../queries/announces/announces.queries';
import { apolloClient } from '../../../plugins/apollo-client';

const getAnnounces = async (type, group) => apolloClient.query({query: GET_ANNOUNCES, variables: { type, group }, fetchPolicy: 'no-cache'});
const createOneAnnounce = async (text, type, group) => apolloClient.mutate({ mutation: CREATE_ONE_ANNOUNCE, variables: { text, type, group }});

export const announcesService = {
  getAnnounces,
  createOneAnnounce,
};